import { User, Match, Thread } from '../types'

export const CURRENT_USER: User = {
  id: 'me',
  name: 'Alex',
  age: 28,
  bio: 'Designer & Coffee enthusiast. Looking for someone to explore the city with.',
  distance: 0,
  photos: [
    'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?q=80&w=1000&auto=format&fit=crop',
    'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?q=80&w=1000&auto=format&fit=crop',
    'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?q=80&w=1000&auto=format&fit=crop',
  ],
  interests: ['Design', 'Coffee', 'Travel', 'Photography'],
  job: 'Product Designer',
  verified: true,
  online: true,
  height: '5\'11"',
  education: 'Rhode Island School of Design',
  lookingFor: 'Long-term partner',
}

export const MOCK_PROFILES: User[] = [
  {
    id: '1',
    name: 'Sarah',
    age: 26,
    bio: "Adventure seeker 🏔️ | Dog mom 🐕 | Always up for tacos. If you can make me laugh, you're already halfway there.",
    distance: 3,
    photos: [
      'https://images.unsplash.com/photo-1494790108377-be9c29b29330?q=80&w=1000&auto=format&fit=crop',
      'https://images.unsplash.com/photo-1524504388940-b1c1722653e1?q=80&w=1000&auto=format&fit=crop',
      'https://images.unsplash.com/photo-1517841905240-472988babdf9?q=80&w=1000&auto=format&fit=crop',
    ],
    interests: ['Hiking', 'Dogs', 'Foodie', 'Travel', 'Sushi'],
    job: 'Marketing Manager',
    company: 'TechFlow',
    verified: true,
    online: true,
    height: '5\'6"',
    education: 'UCLA',
    lookingFor: 'Something casual',
  },
  {
    id: '2',
    name: 'Elena',
    age: 25,
    bio: 'Art history nerd. Museum dates are my love language. 🎨🍷',
    distance: 12,
    photos: [
      'https://images.unsplash.com/photo-1517841905240-472988babdf9?q=80&w=1000&auto=format&fit=crop',
      'https://images.unsplash.com/photo-1534528741775-53994a69daeb?q=80&w=1000&auto=format&fit=crop',
      'https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e?q=80&w=1000&auto=format&fit=crop',
    ],
    interests: ['Art', 'History', 'Wine', 'Museums', 'Reading'],
    job: 'Curator',
    verified: true,
    online: true,
    height: '5\'8"',
    education: 'NYU',
    lookingFor: 'Marriage',
  },
  {
    id: '3',
    name: 'Chloe',
    age: 27,
    bio: 'Yoga instructor. Peace, love, and plants. 🌱 Namaste.',
    distance: 2,
    photos: [
      'https://images.unsplash.com/photo-1524504388940-b1c1722653e1?q=80&w=1000&auto=format&fit=crop',
      'https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e?q=80&w=1000&auto=format&fit=crop',
      'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?q=80&w=1000&auto=format&fit=crop',
    ],
    interests: ['Yoga', 'Plants', 'Wellness', 'Meditation', 'Nature'],
    job: 'Yoga Teacher',
    verified: false,
    online: true,
    height: '5\'5"',
    education: 'Self-taught',
    lookingFor: 'Friends first',
  },
  {
    id: '4',
    name: 'Mia',
    age: 24,
    bio: 'Coffee addict ☕ | Bookworm 📚 | Looking for my partner in crime for spontaneous road trips.',
    distance: 4,
    photos: [
      'https://images.unsplash.com/photo-1488426862026-3ee34a7d66df?q=80&w=1000&auto=format&fit=crop',
      'https://images.unsplash.com/photo-1502323777036-f29e3972f5e8?q=80&w=1000&auto=format&fit=crop',
      'https://images.unsplash.com/photo-1531746020798-e6953c6e8e04?q=80&w=1000&auto=format&fit=crop',
    ],
    interests: ['Coffee', 'Books', 'Road Trips', 'Photography', 'Brunch'],
    job: 'Graphic Designer',
    company: 'Creative Studio',
    verified: true,
    online: false,
    lastActive: '30m ago',
    height: '5\'4"',
    education: 'Parsons School of Design',
    lookingFor: 'Relationship',
  },
  {
    id: '5',
    name: 'Isabella',
    age: 28,
    bio: 'Nurse by profession, dancer by passion 💃 Love salsa nights and beach sunsets.',
    distance: 6,
    photos: [
      'https://images.unsplash.com/photo-1544005313-94ddf0286df2?q=80&w=1000&auto=format&fit=crop',
      'https://images.unsplash.com/photo-1531123897727-8f129e1688ce?q=80&w=1000&auto=format&fit=crop',
      'https://images.unsplash.com/photo-1499557354967-2b2d8910bcca?q=80&w=1000&auto=format&fit=crop',
    ],
    interests: ['Dancing', 'Beach', 'Healthcare', 'Salsa', 'Sunsets'],
    job: 'Registered Nurse',
    company: 'City Hospital',
    verified: true,
    online: true,
    height: '5\'7"',
    education: 'Columbia University',
    lookingFor: 'Long-term partner',
  },
  {
    id: '6',
    name: 'Sophie',
    age: 23,
    bio: "Film student 🎬 Obsessed with indie movies and vinyl records. Let's watch something weird together.",
    distance: 1,
    photos: [
      'https://images.unsplash.com/photo-1502823403499-6ccfcf4fb453?q=80&w=1000&auto=format&fit=crop',
      'https://images.unsplash.com/photo-1485875437342-9b39470b3d95?q=80&w=1000&auto=format&fit=crop',
      'https://images.unsplash.com/photo-1496440737103-cd596325d314?q=80&w=1000&auto=format&fit=crop',
    ],
    interests: ['Films', 'Vinyl', 'Indie Music', 'Art House', 'Thrifting'],
    job: 'Film Student',
    education: 'NYU Tisch',
    verified: false,
    online: true,
    height: '5\'3"',
    lookingFor: 'Something casual',
  },
  {
    id: '7',
    name: 'Olivia',
    age: 29,
    bio: 'Lawyer who loves to unwind with a good hike 🏞️ Wine enthusiast. Dog person.',
    distance: 9,
    photos: [
      'https://images.unsplash.com/photo-1534528741775-53994a69daeb?q=80&w=1000&auto=format&fit=crop',
      'https://images.unsplash.com/photo-1517841905240-472988babdf9?q=80&w=1000&auto=format&fit=crop',
      'https://images.unsplash.com/photo-1524504388940-b1c1722653e1?q=80&w=1000&auto=format&fit=crop',
    ],
    interests: ['Law', 'Hiking', 'Wine', 'Dogs', 'Travel'],
    job: 'Corporate Lawyer',
    company: 'Morrison & Associates',
    verified: true,
    online: false,
    lastActive: '1h ago',
    height: '5\'9"',
    education: 'Harvard Law',
    lookingFor: 'Relationship',
  },
  {
    id: '8',
    name: 'Emma',
    age: 26,
    bio: 'Pastry chef with a sweet tooth 🧁 Making the world a better place, one dessert at a time.',
    distance: 5,
    photos: [
      'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?q=80&w=1000&auto=format&fit=crop',
      'https://images.unsplash.com/photo-1494790108377-be9c29b29330?q=80&w=1000&auto=format&fit=crop',
      'https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e?q=80&w=1000&auto=format&fit=crop',
    ],
    interests: [
      'Baking',
      'Desserts',
      'Food',
      'Cooking Shows',
      'Farmers Markets',
    ],
    job: 'Pastry Chef',
    company: 'Sweet Dreams Bakery',
    verified: true,
    online: true,
    height: '5\'5"',
    education: 'Le Cordon Bleu',
    lookingFor: 'Long-term partner',
  },
  {
    id: '9',
    name: 'Ava',
    age: 25,
    bio: 'Fitness trainer 💪 Early bird who loves sunrise runs. Looking for a gym buddy or more!',
    distance: 3,
    photos: [
      'https://images.unsplash.com/photo-1531746020798-e6953c6e8e04?q=80&w=1000&auto=format&fit=crop',
      'https://images.unsplash.com/photo-1544005313-94ddf0286df2?q=80&w=1000&auto=format&fit=crop',
      'https://images.unsplash.com/photo-1502823403499-6ccfcf4fb453?q=80&w=1000&auto=format&fit=crop',
    ],
    interests: ['Fitness', 'Running', 'Healthy Eating', 'Gym', 'Outdoors'],
    job: 'Personal Trainer',
    company: 'FitLife Gym',
    verified: false,
    online: true,
    height: '5\'6"',
    education: 'Sports Science Degree',
    lookingFor: 'Relationship',
  },
  {
    id: '10',
    name: 'Luna',
    age: 27,
    bio: "Photographer capturing life's moments 📸 Sunset chaser. Always planning the next adventure.",
    distance: 7,
    photos: [
      'https://images.unsplash.com/photo-1499557354967-2b2d8910bcca?q=80&w=1000&auto=format&fit=crop',
      'https://images.unsplash.com/photo-1496440737103-cd596325d314?q=80&w=1000&auto=format&fit=crop',
      'https://images.unsplash.com/photo-1485875437342-9b39470b3d95?q=80&w=1000&auto=format&fit=crop',
    ],
    interests: ['Photography', 'Travel', 'Sunsets', 'Adventure', 'Nature'],
    job: 'Freelance Photographer',
    verified: true,
    online: false,
    lastActive: '15m ago',
    height: '5\'7"',
    education: 'School of Visual Arts',
    lookingFor: 'Something casual',
  },
]

export const MOCK_MATCHES: Match[] = [
  {
    id: 'm1',
    user: MOCK_PROFILES[0],
    matchedAt: '2023-10-25T10:00:00Z',
    hasUnread: true,
  },
  {
    id: 'm2',
    user: MOCK_PROFILES[4],
    matchedAt: '2023-10-24T15:30:00Z',
    hasUnread: false,
  },
  {
    id: 'm3',
    user: MOCK_PROFILES[7],
    matchedAt: '2023-10-23T09:00:00Z',
    hasUnread: true,
  },
]

export const MOCK_THREADS: Thread[] = [
  {
    id: 't1',
    matchId: 'm1',
    user: MOCK_PROFILES[0],
    lastMessage: {
      id: 'msg1',
      senderId: '1',
      text: 'Hey! Love your photos. Have you been to that new taco place downtown?',
      timestamp: '10:30 AM',
      isMe: false,
    },
    unreadCount: 1,
  },
  {
    id: 't2',
    matchId: 'm2',
    user: MOCK_PROFILES[4],
    lastMessage: {
      id: 'msg2',
      senderId: 'me',
      text: "That sounds amazing! I'd love to learn salsa sometime.",
      timestamp: 'Yesterday',
      isMe: true,
    },
    unreadCount: 0,
  },
  {
    id: 't3',
    matchId: 'm3',
    user: MOCK_PROFILES[7],
    lastMessage: {
      id: 'msg3',
      senderId: '8',
      text: 'I just made the most amazing chocolate soufflé! 🍫',
      timestamp: '2 days ago',
      isMe: false,
    },
    unreadCount: 2,
  },
]

export const MOCK_MESSAGES = [
  {
    id: '1',
    senderId: '2',
    text: 'Hey! I see you like music too. What do you play?',
    timestamp: '10:30 AM',
    isMe: false,
  },
  {
    id: '2',
    senderId: 'me',
    text: 'I play a bit of guitar, mostly acoustic. How about you?',
    timestamp: '10:32 AM',
    isMe: true,
  },
  {
    id: '3',
    senderId: '2',
    text: 'Nice! I play bass in a local band. We should jam sometime!',
    timestamp: '10:35 AM',
    isMe: false,
  },
]
